import { ArrayUtils } from '@colonist/utils';
export class TradeEmbargoControllerWriter {
    updatePlayer1EmbargoStateAgainstPlayer2(player1, player2) {
        if (player1 == player2) return;
        if (TradeEmbargoControllerReader.doesPlayer1HaveAnEmbargoAgainstPlayer2(this.embargoState, player1, player2)) {
            this.endPlayer1EmbargoAgainstPlayer2State(player1, player2);
        } else {
            this.startPlayer1EmbargoAgainstPlayer2State(player1, player2);
        }
    }
    endPlayer1EmbargoAgainstPlayer2State(player1, player2) {
        const player1ActiveEmbargoes = TradeEmbargoControllerReader.getActiveEmbargoesForPlayer(this.embargoState, player1);
        ArrayUtils.removeElementFromArray(player1ActiveEmbargoes, player2);
    }
    startPlayer1EmbargoAgainstPlayer2State(player1, player2) {
        const player1ActiveEmbargoes = TradeEmbargoControllerReader.getActiveEmbargoesForPlayer(this.embargoState, player1);
        player1ActiveEmbargoes.push(player2);
    }
    constructor(players, embargoState){
        this.embargoState = embargoState;
        for (const player of players){
            if (!this.embargoState[player]) {
                this.embargoState[player] = {
                    activeEmbargosAgainst: []
                };
            }
        }
    }
}
export class TradeEmbargoControllerReader {
    static getNonEmbargoedPlayersForPlayer(embargoState, player) {
        const nonEmbargoedPlayers = [];
        const allPlayersInGame = Object.keys(embargoState).map((playerColor)=>Number(playerColor));
        const activeEmbargoes = this.getActiveEmbargoesForPlayer(embargoState, player);
        for (const gamePlayer of allPlayersInGame){
            if (gamePlayer == player) continue;
            if (activeEmbargoes.includes(gamePlayer)) continue;
            nonEmbargoedPlayers.push(gamePlayer);
        }
        return nonEmbargoedPlayers;
    }
    static getActiveEmbargoesForPlayer(embargoState, player) {
        var _embargoState_player;
        var _embargoState_player_activeEmbargosAgainst;
        return (_embargoState_player_activeEmbargosAgainst = (_embargoState_player = embargoState[player]) === null || _embargoState_player === void 0 ? void 0 : _embargoState_player.activeEmbargosAgainst) !== null && _embargoState_player_activeEmbargosAgainst !== void 0 ? _embargoState_player_activeEmbargosAgainst : [];
    }
    static didPlayerEmbargoAllOtherPlayers(embargoState, player) {
        const allPlayersInGame = Object.keys(embargoState).map((playerColor)=>Number(playerColor));
        const numberOfPlayers = allPlayersInGame.length;
        if (numberOfPlayers == 1) return false;
        return this.getActiveEmbargoesForPlayer(embargoState, player).length == numberOfPlayers - 1;
    }
    static didEveryoneEmbargoPlayer(embargoState, player) {
        const allPlayersInGame = Object.keys(embargoState).map((playerColor)=>Number(playerColor));
        for (const gamePlayer of allPlayersInGame){
            if (gamePlayer == player) continue;
            if (!this.doesPlayer1HaveAnEmbargoAgainstPlayer2(embargoState, gamePlayer, player)) return false;
        }
        return true;
    }
    static doesPlayer1HaveAnEmbargoAgainstPlayer2(embargoState, player1, player2) {
        const player1ActiveEmbargoes = this.getActiveEmbargoesForPlayer(embargoState, player1);
        return player1ActiveEmbargoes.includes(player2);
    }
}
